export default process.env.NODE_ENV != "production"
  ? {
      node_api_endpoint: "http://192.168.0.95:5053",
      redirect_url: "http://192.168.0.95:3000/sign-up",
    }
  : {
      node_api_endpoint: "https://checkout.kcard.io/api",
      redirect_url: "https://checkout.kcard.io/sign-up",
    };
